<script>
export default {
    name: 'LoginMessageBroker',

    methods: {
        $_loginMessageBroker_notifySuccessfulLogin: function(username) {
            this.$root.$emit('loggedIn', username);
        }
    }
}
</script>